<template>
  <div class="d-flex justify-end mb-3">
    <v-card dark color="primary" class="user-bubble" elevation="0">
      <v-card-text class="py-2 px-3">{{ text }}</v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AgentUserMessage',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.user-bubble {
  max-width: 85%;
  border-radius: 12px;
  white-space: pre-wrap;
  font-size: 14px;
}
</style>
